<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Tenuta dell’Ornellaia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Uno dei vini più costosi d'Italia (un Salamanzar o 12 bottiglie è stato venduto da Christie's a New
                        York per € 18.500 nel 2007, pari a € 22.800 nel 2019), se stai cercando un colosso di
                        Il Chianti allora non cercate oltre. Chiamato il "Petrus d'Italia", se riesci ad aggiungere un caso di
                        Tenuta dell'Ornellaia nel tuo portafoglio, cantina o tavola, allora benvenuto nella grande lega.
                    </div>

                    <div class="howto-title2">Una storia di due fratelli</div>
                    <div class="howto-text">
                        Fratello maggiore e padrino dei vini supertuscan, Piero Antinori è spesso considerato il leader
                        della rivoluzione supertoscana. A non essere da meno è stato però il fratello minore Ludovico.
                        Ereditando una cospicua somma nel 1982, acquista 70 ettari nella Toscana marittima e li impianta con
                        varietà bordolesi. Ha quindi iniziato a creare una tenuta perfetta, assumendo personale rinomato e
                        costruire una cantina all'avanguardia. Quindi, in sostanza, è nata Tenuta dell'Ornellaia
                        Rivalità tra fratelli.
                        <br><br>
                        Non sorprende che la competizione tra fratelli non sarebbe durata. Nonostante la produzione eccellente
                        vini, ne seguirono preoccupazioni finanziarie e Ludovico vendette la sua tenuta nel 2001 a Robert Moldovi. Speranze
                        erano alti su cui la sua eredità sarebbe sopravvissuta ma purtroppo no, nel 2002 Mondovì ha venduto metà della proprietà a
                        la famiglia Frescobaldi. Alla fine neanche questo sarebbe durato: nel 2004 Mondovi ha venduto il suo
                        restante quota del 50% ai giganti commerciali Constellation Brands (famosi per Corona e Funky Buddha).
                        Frescobaldi e Constellation erano ormai soci alla pari ma Ornellaia non aveva ancora trovato il suo
                        la tranquillità. Finalmente, nel 2005, Frescobaldi assume il controllo completo della tenuta e si mette in moto
                        l'attività di fare del vino davvero buono.
                    </div>

                    <div class="howto-title2">Winez meanz Heinz</div>
                    <div class="howto-text">
                        Come un figlio di genitori litigiosi e divorziati, dobbiamo chiederci se tutto lo sconvolgimento abbia avuto
                        questo ha influito sul vino? Fortunatamente no. Nonostante le diverse visioni del proprietario di Ornellaia, insieme
                        con l'arrivo dell'enologo senior Axel Heinz e Ornellaia è finalmente arrivato il momento di brillare
                        arrivato. La prima annata di Heinz nel 2006 è stata bollata come "magnifica" e premiata con 97 punti da
                        Antonio Gallioni di Vinoso. Usando il suo tocco magico, Axel ha trovato il punto giusto per la miscela:
                        tra 50-60% Cabernet Sauvignon, 20/25% Merlot e 15% Cabernet Franc, con una stagionatura di
                        Petit Verdot a volte buttato dentro, a seconda dell'annata. Questo ha avuto successo per
                        Ornellia, e il Giacosa Quintarelli è il vino attualmente più costoso (tra i 400-500 euro).
                        Il Masseto, il summenzionato vino gemello venduto all'asta nel 2007, è il punto di riferimento di tutti
                        vini super-toscani.
                        <br><br>
                        Ornellaia è uno dei componenti più performanti dell'indice Liv-ex Italy 50 e la poca volatilità rende molto allettante qualsiasi investimento nel vino pregiato.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Tenuta dell’Ornellaia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Einer der teuersten Weine Italiens (ein Salamanzar oder eine 12er-Flasche wurde bei Christie's in New York verkauft
                        York für 18.500 € im Jahr 2007, das entspricht 22.800 € im Jahr 2019), wenn Sie auf der Suche nach einem Giganten sind
                        Dann sind Sie bei Chianti genau richtig. Wird „Petrus von Italien“ genannt, wenn man es überhaupt hinbekommt
                        Tenuta dell’Ornellaia in Ihrem Portfolio, Keller oder Tisch, dann willkommen in der großen Liga.
                    </div>

                    <div class="howto-title2">Eine Geschichte von zwei Brüdern</div>
                    <div class="howto-text">
                        Piero Antinori, älterer Bruder und Pate der toskanischen Spitzenweine, wird oft als der Anführer angesehen
                        der übertoskanischen Revolution. Nicht zu übertreffen war jedoch sein jüngerer Bruder Ludovico.
                        Als er 1982 eine große Summe erbte, kaufte er 70 Hektar Land in der maritimen Toskana und bepflanzte es
                        Bordeaux-Sorten. Anschließend machte er sich daran, ein perfektes Anwesen zu schaffen, renommiertes Personal einzustellen und
                        Aufbau eines hochmodernen Weinguts. Tenuta dell’Ornellaia entstand also im Wesentlichen daraus
                        Rivalität unter Geschwistern.
                        <br><br>
                        Es überrascht nicht, dass der Wettbewerb zwischen Brüdern nicht von Dauer sein würde. Trotz ausgezeichneter Produktion
                        Weine, finanzielle Sorgen folgten und Ludovico verkaufte sein Anwesen im Jahr 2001 an Robert Moldovi. Hoffnungen
                        Es war hoch, dass sein Vermächtnis weiterleben würde, aber leider nein, im Jahr 2002 verkaufte Mondovi die Hälfte des Anwesens an
                        die Familie Frescobaldi. Letztendlich sollte auch das nicht von Dauer sein – 2004 verkaufte Mondovi sein eigenes
                        verbleibende 50 % der Anteile an die kommerziellen Giganten Constellation Brands (bekannt für Corona und Funky Buddha).
                        Frescobaldi und Constellation waren nun gleichberechtigte Partner, aber Ornellaia hatte noch immer keinen Partner gefunden
                        Ruhe. Im Jahr 2005 übernahm Frescobaldi schließlich die vollständige Kontrolle über das Anwesen und machte sich daran
                        das Geschäft, wirklich guten Wein herzustellen.
                    </div>

                    <div class="howto-title2">Winez bedeutet Heinz</div>
                    <div class="howto-text">
                        Wie ein Kind streitender, sich scheidender Eltern müssen wir uns fragen, ob all die Umwälzungen das auch getan haben
                        Hat sich das auf den Wein ausgewirkt? Zum Glück nein. Trotz der unterschiedlichen Visionen von Ornellaias Besitzer, weiter
                        Mit der Ankunft des leitenden Winzers Axel Heinz und Ornellaia ist es endlich an der Zeit zu glänzen
                        angekommen. Der erste Jahrgang von Heinz im Jahr 2006 wurde als „großartig“ eingestuft und mit 97 Punkten ausgezeichnet
                        Antonio Gallioni von Vinous. Mit seinem magischen Gespür hat Axel den idealen Punkt für die Mischung gefunden:
                        zwischen 50-60 % Cabernet Sauvignon, 20/25 % Merlot und 15 % Cabernet Franc, mit einer Würze von
                        Je nach Jahrgang wird manchmal Petit Verdot hinzugefügt. Dies hat sich bewährt
                        Ornellia, und der Giacosa Quintarelli ist derzeit der teuerste Wein (zwischen 400 und 500 €).
                        Masseto, der oben erwähnte Schwesterwein, der 2007 auf einer Auktion verkauft wurde, ist der Maßstab von allen
                        Supertoskanische Weine.
                        <br><br>
                        Ornellaia ist einer der leistungsstärksten Bestandteile des Liv-ex Italy 50 Index und die geringe Volatilität macht jede Investition in den edlen Wein sehr verlockend.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Tenuta dell’Ornellaia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        L'un des vins les plus chers d'Italie (un Salamanzar ou 12 bouteilles a été vendu chez Christie's à New
                        York pour 18 500 € en 2007, équivalent à 22 800 € en 2019), si vous cherchez un mastodonte d'un
                        Chianti alors ne cherchez pas plus loin. Nommé le "Petrus d'Italie", si vous parvenez à ajouter une caisse de
                        Tenuta dell'Ornellaia à votre portefeuille, cave ou table, alors bienvenue dans la cour des grands.
                    </div>

                    <div class="howto-title2">L'histoire de deux frères</div>
                    <div class="howto-text">
                        Frère aîné et parrain des super vins toscans, Piero Antinori est souvent considéré comme le leader
                        de la révolution super-toscane. Cependant, le jeune frère Ludovico n'a pas été en reste.
                        Héritant d'une grosse somme en 1982, il achète 70 hectares en Toscane maritime et les plante avec
                        Variétés bordelaises. Il s'est alors attelé à créer un domaine parfait, à embaucher du personnel de renom et
                        construire une cave à la pointe de la technologie. Donc, essentiellement, Tenuta dell'Ornellaia est née de
                        La rivalité fraternelle.
                        <br><br>
                        Sans surprise, la compétition entre frères ne durera pas. Malgré la production d'excellents
                        vins, des soucis financiers s'ensuivent et Ludovico vend son domaine en 2001 à Robert Moldovi. Espoirs
                        étaient élevés que son héritage vivrait mais malheureusement non, en 2002, Mondovi a vendu la moitié du domaine à
                        la famille Frescobaldi. En fin de compte, cela n'a pas duré non plus - en 2004, Mondovi a vendu son
                        la participation restante de 50% aux géants commerciaux Constellation Brands (de renommée Corona et Funky Buddha).
                        Frescobaldi et Constellation étaient désormais des partenaires égaux mais Ornellaia n'avait toujours pas trouvé son
                        tranquillité. Enfin, en 2005, Frescobaldi prend le contrôle total du domaine et entreprend
                        l'entreprise de faire du très bon vin.
                    </div>

                    <div class="howto-title2">Winez signifie Heinz</div>
                    <div class="howto-text">
                        Comme un enfant de parents qui se chamaillent et divorcent, nous devons nous demander si tout ce bouleversement a
                        cela a affecté le vin? Heureusement non. Malgré les visions divergentes du propriétaire d'Ornellaia, le long
                        avec l'arrivée du vigneron senior Axel Heinz et le temps de briller d'Ornellaia a enfin
                        arrivé. Le premier millésime de Heinz en 2006 a été marqué "magnifique" et a obtenu 97 points par
                        Antonio Gallioni de Vinous. Grâce à sa touche magique, Axel a trouvé le bon endroit pour le mélange :
                        entre 50-60% Cabernet Sauvignon, 20/25% Merlot et 15% Cabernet Franc, avec un assaisonnement de
                        Petit Verdot parfois rajouté selon les millésimes. Cela a fait ses preuves pour
                        Ornellia, et le Giacosa Quintarelli est le vin le plus cher actuellement (entre 400 et 500 €).
                        Masseto, le vin-soeur susmentionné vendu aux enchères en 2007 est la référence de tous
                        vins super toscans.
                        <br><br>
                        Ornellaia est l'un des composants les plus performants de l'indice Liv-ex Italy 50 et sa faible volatilité rend tout investissement dans le vin fin très tentant.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Tenuta dell’Ornellaia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        One of Italy’s most expensive wines (a Salamanzar or 12-bottle was sold at Christie's in New
                        York for €18,500 in 2007, equivalent to €22,800 in 2019), if you’re looking for a behemoth of a
                        Chianti then look no further. Named the “Petrus of Italy”, if you can manage to add a case of
                        Tenuta dell’Ornellaia to your portfolio, cellar or table then welcome to the big league.
                    </div>

                    <div class="howto-title2">A tale of two brothers</div>
                    <div class="howto-text">
                        Older brother and Godfather of super Tuscan wines, Piero Antinori is often considered the leader
                        of the super-Tuscan revolution. Not to be outdone however was younger brother Ludovico.
                        Inheriting a large sum in 1982, he bought 70-hectares in maritime Tuscany and planted them with
                        Bordeaux varieties. He then set about creating a perfect estate, hiring renowned staff and
                        building a state of the art winery. So essentially, Tenuta dell’Ornellaia was born out of
                        sibling rivalry.
                        <br><br>
                        Unsurprisingly, the competition between brothers wouldn’t last. Despite producing excellent
                        wines, financial worries ensued and Ludovico sold his estate in 2001 to Robert Moldovi. Hopes
                        were high that his legacy would live on but sadly no, in 2002 Mondovi sold half the estate to
                        the Frescobaldi family. Ultimately that wouldn't last either - in 2004 Mondovi sold his
                        remaining 50% stake to commercial giants Constellation Brands (of Corona and Funky Buddha fame).
                        Frescobaldi and Constellation were now equal partners but Ornellaia had still not found its
                        tranquillity. Finally, in 2005, Frescobaldi took complete control of the estate and set about
                        the business of making some seriously good wine.
                    </div>

                    <div class="howto-title2">Winez meanz Heinz</div>
                    <div class="howto-text">
                        Like a child of bickering, divorcing parents, we have to wonder whether all the upheaval has
                        this affected the wine? Happily no. Despite the differing visions of Ornellaia’s owner, along
                        with the arrival of senior winemaker Axel Heinz and Ornellaia’s time to shine has finally
                        arrived. Heinz’s first vintage in 2006 was branded “magnificent” and awarded 97 points by
                        Antonio Gallioni of Vinous. Using his magic touch, Axel has found the sweet spot for the blend:
                        between 50-60% Cabernet Sauvignon, 20/25% Merlot and 15% Cabernet Franc, with a seasoning of
                        Petit Verdot sometimes thrown in, depending on the vintage. This has proved successful for
                        Ornellia, and the Giacosa Quintarelli is the most currently expensive wine (between €400-500).
                        Masseto, the above-mentioned sister-wine sold at auction in 2007 is the benchmark of all
                        super-Tuscan wines.
                        <br><br>
                        Ornellaia is one of the best performing components of the Liv-ex Italy 50 index and little volatility makes any investment in the fine wine very tempting.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TenutaDellOrnellaia",
    head: {
        title: 'Tenuta dell’Ornellaia | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the finest wine-making traditions at Tenuta dell’Ornellaia, a renowned wine producer in Tuscany, Italy. Experience the rich history, passion and expertise behind every bottle of their premium, handcrafted wines. Explore the diverse selection of red, white and rose wines from this iconic producer and taste the elegance of Tuscany in every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
